import { Box, Input, Select, Spinner, useBreakpointIndex } from '@apia/theme';
import { useAutocompleteContext } from './Context';
import { observer } from 'mobx-react-lite';
import { Icon } from '@apia/icons';

export const SearchBox = observer(() => {
  const handler = useAutocompleteContext();
  const breakpoint = useBreakpointIndex();

  return (
    <Box className="autocomplete__inputWrapper">
      <input
        type="hidden"
        name={handler.state.name}
        value={handler.state.value}
      />
      {breakpoint <= 3 ? (
        <Select
          disabled={handler.state.disabled}
          onChange={(ev) => {
            handler.setValue(ev.target.value);
          }}
        >
          {handler.state.options.map((c) => (
            <option key={c.value} value={c.value}>
              {c.label}
            </option>
          ))}
        </Select>
      ) : (
        <>
          <Input
            className={`autocomplete__search ${handler.state.disabled ? 'disabled' : ''}`}
            onChange={(ev) => {
              handler.search(ev.target.value);
              handler.state.showValue = ev.target.value;
            }}
            onMouseDown={() => {
              handler.toggleOpen();
            }}
            onFocus={(ev) => {
              ev.target.setSelectionRange(0, ev.target.value.length);
            }}
            onBlur={() => {
              handler.close();
            }}
            value={handler.state.showValue}
          />
          <Box className="autocomplete__icons">
            {handler.state.loading && (
              <Spinner className="autocomplete__loadingSpinner" />
            )}
            <Icon
              title=""
              name="ArrowDown"
              className="autocomplete__downArrow"
            />
          </Box>
        </>
      )}
    </Box>
  );
});
